import { render, staticRenderFns } from "./RealEstateCard.vue?vue&type=template&id=0c9a8394&scoped=true&"
import script from "./RealEstateCard.vue?vue&type=script&lang=js&"
export * from "./RealEstateCard.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateCard.vue?vue&type=style&index=0&id=0c9a8394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a8394",
  null
  
)

export default component.exports